export const CHANGE_FILTERS = 'people/CHANGE_FILTERS'

export const REFRESH_ONBOARDING_RECOMMENDATIONS = 'people/REFRESH_ONBOARDING_RECOMMENDATIONS' // prettier-ignore
export const REFRESH_ONBOARDING_RECOMMENDATIONS_ERROR = 'people/REFRESH_ONBOARDING_RECOMMENDATIONS_ERROR' // prettier-ignore
export const REFRESH_ONBOARDING_RECOMMENDATIONS_SUCCESS = 'people/REFRESH_ONBOARDING_RECOMMENDATIONS_SUCCESS' // prettier-ignore

export const RESET_ONBOARDING_RECOMMENDATIONS = 'people/RESET_ONBOARDING_RECOMMENDATIONS' // prettier-ignore
